import { Flex, Text } from '@mantine/core';
import { IconChevronDown, IconChevronUp } from '@tabler/icons-react';

const CustomFormLabel = ({ name, inputName, iconSetting: IconSetting, handleToggle, isSectionOpen }) => {
  return (
    <Text
      component="div"
      onClick={() => handleToggle(inputName)}
      mb="xs"
      style={{ display: 'block', cursor: 'pointer' }}
    >
      <Flex align="center">
        <IconSetting size={16} style={{ marginRight: 8 }} />
        <span style={{ flexGrow: 1 }}>{name}</span>
        {isSectionOpen(inputName) ? (
          <IconChevronUp size={14} style={{ marginLeft: 'auto' }} />
        ) : (
          <IconChevronDown size={14} style={{ marginLeft: 'auto' }} />
        )}
      </Flex>
    </Text>
  );
};

export default CustomFormLabel;
